import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DigitalSignatureCommonService } from '@app/requests/logalty-digital-signature/digital-signature-service/digital-signature-common.service ';
import { DigitalSignatureServiceStore } from '@app/requests/logalty-digital-signature/digital-signature-service/digital-signature-service.store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-logalty-call-back-image',
  templateUrl: './logalty-call-back-image.component.html',
  styleUrls: ['./logalty-call-back-image.component.scss'],
})
export class LogaltyCallBackImageComponent implements OnInit {
  public numOperation: string;
  public responseOK: boolean = false;
  public guid: string;
  public feedback: string;
  public isAsync: boolean = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public translate: TranslateService,
    private digitalSignatureCommonService: DigitalSignatureCommonService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.guid = params['nodeid'];
      this.feedback = params['feedback'];
      this.feedback = decodeURIComponent(this.feedback).replace(/(\r\n|\n|\r)/gm, '');
      let exp = /<signature_states>(.*?)<\/signature_states>/g;
      let signature_states = this.feedback.match(exp);

      let valueDate: Date;
      let stateValid: string;
      if (signature_states && signature_states.length > 0) {
        signature_states.forEach((state) => {
          if (valueDate === undefined) {
            valueDate = new Date(state.split('+date=')[1].split('"+')[0]);
            stateValid = state.split('+value=')[1].split('"')[1];
          } else if (new Date(state.split('+date=')[1].split('"+')[1]) > valueDate) {
            valueDate = new Date(state.split('+date=')[1].split('"')[0]);
            stateValid = state.split('+value=')[1].split('"')[1];
          }
        });
      } else {
        let valueState = signature_states[0].split('+value=');
        stateValid = valueState[1].split('"')[1];
      }

      if (this.digitalSignatureCommonService.getDataAsynSignature() !== null) {
        this.isAsync = true;
      }

      this.numOperation = this.digitalSignatureCommonService.getNumOperationSignature();

      if (stateValid === '7') {
        this.responseOK = true;
      } else {
        this.responseOK = false;
      }
    });
  }
}
